module.exports = __webpack_public_path__ + "static/assets/99f32b8bd33742b19f6568742684750c.svg";